export default __webpack_public_path__ + "static/media/BrainBreak cards21.e5dceee1.png";